const BASEURL = process.env.VUE_APP_BASEURL
const ADMIN_BASEURL = process.env.VUE_APP_ADMIN_BASEURL
// const BASEURL = 'https://api.snappyexchange.com/api'

export { BASEURL, ADMIN_BASEURL }
